import React from 'react';
import { connect } from 'react-redux';
import { differenceInDays, differenceInMonths, differenceInWeeks, differenceInYears } from 'date-fns';
import { updateData } from "../actions";
import ControlService from '../../helper/controlservice';

const _ = require('lodash');

function mapStateToProps(state) {
    return {
        data: state.formDataReducer,
        filterdata: state.formDataReducer.filterdata,
        editformdata: state.formDataReducer.editformdata,
    };
}
function bindAction(dispatch) {
    return {
        update: async (key, value, storekey) => dispatch(updateData(key, value, storekey)),
    };
}
class Expression extends React.PureComponent {
    constructor() {
        super();

        this.state = {
            data: {},
            value: 0
        }
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.data && nextProps.data[nextProps.formid] != prevState.data) {
            return {
                data: nextProps.data[nextProps.formid]
            };
        }
        else return null; // Triggers no change in the state
    }
    componentDidMount() {
        this.setState({ value: this.state.data && this.state.data[this.props.control.key] ? this.state.data[this.props.control.key] : 0 })
    }
    async componentDidUpdate(prevProps, prevState) {
        const { data } = this.state;
        const { control, formid } = this.props;

        var _value = data && data[control.key] ? data[control.key] : 0;

        var value = this.evaluate(control, this.state.data);
        value = value && value !== 'NaN' && value !== 'Infinity' ? value : 0

        if (ControlService().isEmptyorNull(value) && ControlService().isEmptyorNull(_value)) {
            value = 0;
            _value = 0;
        }

        if (_value !== value) {
            await this.props.update(control.key, value, formid)
            this.setState({ value: value });
        }
    }
    getOpration(data) {
        var operation = "0";
        this.props.control.operation.forEach(item => {
            if (operation == "0") {
                if (item.type == "value") {
                    operation = data[item.data] ? data[item.data] : "0";
                } else {
                    operation = item.data;
                }
            } else {
                if (item.type == "value") {
                    operation += data[item.data] ? data[item.data] : "0";
                } else {
                    operation += item.data;
                }
            }
        })
        return operation;
    }
    evaluate(control, data) {
        try {
            var _data = "";
            if (control.isdatediff) {
                var Lablevaleu = "";
                if (control.operation.length == 3) {
                    const _date1 = data[control.operation[0].data];
                    const _date2 = data[control.operation[2].data];

                    const date1 = new Date(_date1);
                    const date2 = new Date(_date2);
                    if (_date1 && _date2) {
                        switch (control.datedifftype) {
                            case "day":
                                _data = differenceInDays(date1, date2);
                                if (control.isnumber)
                                    Lablevaleu = _data
                                else
                                    Lablevaleu = _data + " Day(s)"
                                break;
                            case "week":
                                _data = differenceInWeeks(date1, date2);
                                if (control.isnumber)
                                    Lablevaleu = _data
                                else
                                    Lablevaleu = _data + " Week(s)";
                                var days = ((differenceInDays(date1, date2)) % 7);
                                // var w = diff.weeks();
                                if (!isNaN(_data)) {
                                    Lablevaleu = Math.floor(_data) + " Week(s)";

                                    if (Lablevaleu == "NaN Week(s)") {
                                        if (control.isnumber)
                                            Lablevaleu = 0
                                        else
                                            Lablevaleu = "0 Week(s)";
                                    }
                                }
                                else {
                                    if (control.isnumber)
                                        Lablevaleu = 0
                                    else
                                        Lablevaleu = "0 Week(s)"
                                }
                                if (days > 0) {
                                    if (control.isnumber)
                                        Lablevaleu = parseFloat(Lablevaleu + '.' + days);
                                    else
                                        Lablevaleu += " and " + days + " Day(s)";
                                }

                                break;
                            case "month":
                                _data = differenceInMonths(date1, date2);
                                // if (diff.months() != null) {
                                if (control.isnumber)
                                    Lablevaleu = _data;
                                else
                                    Lablevaleu = _data + " Month(s)";
                                if (Lablevaleu == "NaN Month(s)") {
                                    if (control.isnumber)
                                        Lablevaleu = 0;
                                    else
                                        Lablevaleu = "0 Month(s)";
                                }
                                // } else {
                                //     Lablevaleu = "0 Month(s)";
                                // }
                                var _dataDays = differenceInDays(date1, date2);
                                if (((_dataDays / (_data * 30)) % 1) != 0) {
                                    const value = _data * 30;
                                    if (control.isnumber)
                                        Lablevaleu = parseFloat(Lablevaleu + '.' + (_dataDays - value));
                                    else
                                        Lablevaleu += " and " + (_dataDays - value) + " Day(s)";
                                }


                                break;
                            case "year":
                                _data = differenceInYears(date1, date2);
                                if (control.isnumber)
                                    Lablevaleu = _data;
                                else
                                    Lablevaleu = _data + " Year(s)"
                                break;
                            default:
                                break;

                        }
                    }
                }
                return Lablevaleu;

            } else {
                var operation = this.getOpration(data);
                console.log(control.key + '~' + operation);
                _data = eval(operation);
                _data = Number.isInteger(_data) ? _data : _data.toFixed(control.decimalplaces ? control.decimalplaces : 2);
            }
        }
        catch (e) {
            _data = 0;
        }
        return _data;
    }
    gethtml(control, data) {
        var s = "<" + control.formattype + ">" + ControlService().numberToCommas(this.state.value) + "</" + control.formattype + ">";
        return s;
    }
    render() {
        const { control } = this.props;
        return (
            control.hidden ?
                null
                :
                <div className="form-group">
                    {control.label && <label>{control.label}</label>}
                    <div className={(control.customClass) + " form-control border-transparent px-0"} ><span dangerouslySetInnerHTML={{ __html: this.gethtml(control) }}></span></div>
                </div>
        );
    }
}

export default connect(
    mapStateToProps, bindAction
)(Expression);